module.exports = __webpack_public_path__ + "img/select-triangle.649bf51d.svg";